import { forwardRef } from "react";
import { Button, Input, Tooltip } from "@mui/material";
import { tss } from "tss-react";

import { VisibilityOff, CenterFocusStrong, RemoveCircle } from "@mui/icons-material";
import { LayersDuplicate } from "assets/images/index";
import LayerOpacity from "assets/images/ic_opacity.svg";
import commonStyles from "styles/common";

const useStyles = tss.create({
    borderNone: {
        border: "none",
        minWidth: 16,
        width: 52,
    },
    disabled: {
        opacity: 0.25,
    },
    opacityInput: {
        "& input": {
            width: 53,
            height: 15,
            outline: 0,
            border: 0,
            borderBottom: "solid 1px #adbbd3",
            textAlign: "center",
            fontSize: 14,
            letterSpacing: 0,
            lineHeight: "16px",
            backgroundColor: "transparent",
        },
    },
});

type IProps = {
    isVisible: boolean;
    opacity: number;
    toggleVisibility?: () => void;
    setTransparency?: (evt: any) => void;
    zoomToLayer?: () => void;
    confirmDelete?: () => void;
    className?: any;
    style?: any;
};

const Toolbar = forwardRef((props: IProps, ref: any) => {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    const { isVisible, opacity, toggleVisibility, setTransparency, zoomToLayer, confirmDelete, className, style } =
        props;

    return (
        <div className={className} style={style}>
            <Tooltip title="Duplicate" placement="bottom" arrow>
                <Button size="small" className={classes.borderNone} disabled={true}>
                    <LayersDuplicate className={common.disabled} />
                </Button>
            </Tooltip>
            <Tooltip title="Show/Hide" placement="bottom" arrow>
                <Button
                    size="small"
                    className={isVisible ? classes.borderNone : [classes.borderNone, classes.disabled].join(" ")}
                    onClick={toggleVisibility}
                >
                    <VisibilityOff className={common.shaded} />
                </Button>
            </Tooltip>
            <Tooltip title="Zoom to layer" placement="bottom" arrow>
                <Button 
                    className={classes.borderNone}
                    onClick={zoomToLayer} 
                    disabled={!zoomToLayer}
                >
                    <CenterFocusStrong className={!zoomToLayer ? common.disableEventsNoShades : common.shaded} />
                </Button>
            </Tooltip>
            <Tooltip title="Delete" placement="bottom" arrow>
                <Button className={classes.borderNone} onClick={confirmDelete} disabled={!confirmDelete}>
                    <RemoveCircle className={!confirmDelete ? common.disableEventsNoShades : common.shaded} />
                </Button>
            </Tooltip>
            <div
                style={{
                    borderLeft: "solid 1px #E6E6E6",
                    display: "inline-block",
                    paddingLeft: 15,
                }}
            >
                <img src={LayerOpacity} alt="Layer opacity" style={{ position: "relative", top: 4, right: 6 }} />
                <Input
                    type="number"
                    id="layer_properties_opacity"
                    value={Math.round(opacity)}
                    className={classes.opacityInput}
                    inputProps={{ min: 0, max: 100, step: 1 }}
                    onChange={setTransparency}
                />
            </div>
        </div>
    );
});
export default Toolbar;
